export default function filterPropertyDefinitions(properties, fn) {
	const filteredPropertyDefs = {};
	for (const k in properties) {
		const value = properties[k];
		if (fn(value)) filteredPropertyDefs[k] = value;
	}

	return filteredPropertyDefs;
}
